"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var shimmerAnimation = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% { transform: translateX(-100%) translateY(-50%) rotate(15deg);  }\n  100% { transform: translateX(100%) translateY(-50%) rotate(15deg); }\n"])));
var shimmer = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &::after {\n    content: \"\";\n    position: absolute;\n    z-index: 3;\n    top: 50%;\n    left: 0;\n    width: 280px;\n    height: 1200px;\n    background: ", ";\n    animation: ", " 1500ms linear infinite;\n  }\n"])), function (p) {
  return p.skeletonColorShimmer;
}, shimmerAnimation);

var StyledShimmerSvg = _styledComponents.default.svg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  animation: ", " 1500ms linear infinite;\n"])), shimmerAnimation);

var StyledShimmerPath = _styledComponents.default.path(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  fill: ", ";\n"])), function (p) {
  return p.skeletonColorShimmer || p.theme.colorSkeletonShimmer;
});

var StyledSkeleton = _styledComponents.default.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: ", ";\n  position: relative;\n  overflow: hidden;\n  border-radius: ", ";\n  background: ", ";\n  width: ", ";\n  height: ", ";\n  margin: ", ";\n  -webkit-mask-image: -webkit-radial-gradient(white, black);\n"])), function (p) {
  return p.display;
}, function (p) {
  return p.isCircle ? "50%" : p.skeletonBorderRadius || p.theme.borderRadius;
}, function (p) {
  return p.skeletonColorBackground || p.theme.colorSkeleton;
}, function (p) {
  return p.skeletonWidth;
}, function (p) {
  return p.skeletonHeight;
}, function (p) {
  return p.margin;
});

var Skeleton = function Skeleton(_ref) {
  var noShimmer = _ref.noShimmer,
      className = _ref.className,
      skeletonWidth = _ref.skeletonWidth,
      skeletonHeight = _ref.skeletonHeight,
      skeletonBorderRadius = _ref.skeletonBorderRadius,
      skeletonColorBackground = _ref.skeletonColorBackground,
      skeletonColorShimmer = _ref.skeletonColorShimmer,
      isCircle = _ref.isCircle,
      margin = _ref.margin,
      display = _ref.display;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSkeleton, {
    className: className,
    skeletonWidth: skeletonWidth,
    skeletonHeight: skeletonHeight,
    skeletonBorderRadius: skeletonBorderRadius,
    skeletonColorBackground: skeletonColorBackground,
    isCircle: isCircle,
    margin: margin,
    display: display,
    noShimmer: noShimmer,
    children: !noShimmer && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledShimmerSvg, {
      width: "500",
      height: "400",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledShimmerPath, {
        skeletonColorShimmer: skeletonColorShimmer,
        d: "M151 0.5H431L280 1200H0L151 0.5Z"
      })
    })
  });
};

Skeleton.defaultProps = {
  skeletonWidth: "100px",
  skeletonHeight: "10px",
  isCircle: false,
  margin: "0",
  display: "inline-block"
};
Skeleton.propTypes = {
  skeletonColorBackground: _propTypes.default.string,
  skeletonColorShimmer: _propTypes.default.string,
  skeletonWidth: _propTypes.default.string,
  skeletonHeight: _propTypes.default.string,
  skeletonBorderRadius: _propTypes.default.string,
  isCircle: _propTypes.default.bool,
  margin: _propTypes.default.string,
  display: _propTypes.default.string
};
var _default = Skeleton;
exports.default = _default;